import { render, staticRenderFns } from "./FaqDspPartner.vue?vue&type=template&id=692acbc6&"
import script from "./FaqDspPartner.vue?vue&type=script&lang=js&"
export * from "./FaqDspPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports